import { apiClient } from "lib/apiClient";
import { compactResearchParams } from "features/Research/constants";
import {
  IResearchProductivityDay,
  IResearchProductivityRequest,
} from "features/Research/types";

export const getResearchProductivity = async (
  request: IResearchProductivityRequest
): Promise<IResearchProductivityDay[]> => {
  const response = await apiClient.get("/research/productivity", {
    params: compactResearchParams(request),
  });
  return response.data;
};
